import { InitiateQRPaymentComponent } from "Components/QRPayment/InitiateQRPaymentComponent";
import { ResponsiveDialog } from "Components/Shared/Dialogs/ResponsiveDialog";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import type { PartyLicenseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  license: PartyLicenseDto;
};

export const PendingLicensePaymentDialog = ({
  isOpen,
  onClose,
  license: { transactionPublicID },
}: Props) => {
  const { t } = useResource();

  return (
    <ResponsiveDialog
      title={t(Resources.Hunter.LicensePaymentPending.PaymentDetailsTitle)}
      isOpen={isOpen}
      onClose={onClose}
    >
      {transactionPublicID ? (
        <InitiateQRPaymentComponent
          publicID={transactionPublicID}
          isEnabled={isOpen}
        />
      ) : (
        <ErrorText>{t(Resources.Errors.RequestError)}</ErrorText>
      )}
    </ResponsiveDialog>
  );
};
